import React from 'react';
import { BuildingIcon, FileTextIcon, CreditCardIcon, CalendarIcon, ArrowRightIcon } from 'lucide-react';
export function IUVSection() {
  return <section className="w-full bg-bg-primary py-16 md:py-24 px-4" data-id="element-255">
      <div className="max-w-6xl mx-auto" data-id="element-256">
        <div className="text-center mb-12 md:mb-20" data-id="element-257">
          <div className="inline-block bg-cta/10 text-cta text-xs md:text-sm font-semibold px-3 md:px-4 py-1.5 md:py-2 rounded-full mb-4 md:mb-6" data-id="element-258">
            El Sistema Completo
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6" data-id="element-259">
            Infraestructura Única de Valor
          </h2>
          <p className="text-base md:text-xl text-text-secondary leading-relaxed max-w-3xl mx-auto" data-id="element-260">
            Un sistema de 4 pilares fundamentales que deben construirse en orden
            secuencial. Cada pilar depende del anterior. Saltar uno crea
            vulnerabilidades.
          </p>
        </div>

        <div className="space-y-6 md:space-y-8" data-id="element-261">
          {/* Pilar 1 */}
          <div className="bg-bg-card p-6 md:p-8 lg:p-10 rounded-xl border border-cta/20 hover:border-cta/40 transition-colors" data-id="element-262">
            <div className="flex items-start gap-4 md:gap-6" data-id="element-263">
              <div className="flex-shrink-0" data-id="element-264">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-cta/10 rounded-lg flex items-center justify-center" data-id="element-265">
                  <BuildingIcon className="w-6 h-6 md:w-8 md:h-8 text-cta" data-id="element-266" />
                </div>
              </div>
              <div className="flex-1" data-id="element-267">
                <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4" data-id="element-268">
                  <span className="text-cta font-bold text-base md:text-lg" data-id="element-269">
                    Pilar 1
                  </span>
                  <div className="h-px bg-cta/30 flex-1" data-id="element-270"></div>
                </div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-bold mb-2 md:mb-3" data-id="element-271">
                  Registrar — Autonomía Legal
                </h3>
                <p className="text-text-secondary text-sm md:text-base lg:text-lg leading-relaxed mb-4 md:mb-6" data-id="element-272">
                  El proceso de crear formalmente la empresa ante el estado y
                  establecer su existencia legal.
                </p>
                <div className="space-y-2 md:space-y-3" data-id="element-273">
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-274">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-275" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-276">
                      Elegir entre LLC o Corporation
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-277">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-278" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-279">
                      Registrar la empresa ante el Secretary of State
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-280">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-281" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-282">
                      Crear el Operating Agreement
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-283">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-284" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-285">
                      Establecer la base legal de la empresa
                    </span>
                  </div>
                </div>
                <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-cta/20" data-id="element-286">
                  <p className="text-cta font-semibold text-sm md:text-base" data-id="element-287">
                    Resultado: La empresa existe legalmente
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Arrow */}
          <div className="flex justify-center" data-id="element-288">
            <div className="w-px h-8 md:h-12 bg-gradient-to-b from-cta/50 to-cta/20" data-id="element-289"></div>
          </div>

          {/* Pilar 2 */}
          <div className="bg-bg-card p-6 md:p-8 lg:p-10 rounded-xl border border-cta/20 hover:border-cta/40 transition-colors" data-id="element-290">
            <div className="flex items-start gap-4 md:gap-6" data-id="element-291">
              <div className="flex-shrink-0" data-id="element-292">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-cta/10 rounded-lg flex items-center justify-center" data-id="element-293">
                  <FileTextIcon className="w-6 h-6 md:w-8 md:h-8 text-cta" data-id="element-294" />
                </div>
              </div>
              <div className="flex-1" data-id="element-295">
                <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4" data-id="element-296">
                  <span className="text-cta font-bold text-base md:text-lg" data-id="element-297">
                    Pilar 2
                  </span>
                  <div className="h-px bg-cta/30 flex-1" data-id="element-298"></div>
                </div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-bold mb-2 md:mb-3" data-id="element-299">
                  Estructurar — Inteligencia Fiscal
                </h3>
                <p className="text-text-secondary text-sm md:text-base lg:text-lg leading-relaxed mb-4 md:mb-6" data-id="element-300">
                  El proceso de crear la identidad fiscal de la empresa ante el
                  IRS.
                </p>
                <div className="space-y-2 md:space-y-3" data-id="element-301">
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-302">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-303" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-304">
                      Obtener el EIN
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-305">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-306" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-307">
                      Entender cómo funciona el sistema fiscal empresarial
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-308">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-309" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-310">
                      Configurar correctamente la identidad fiscal de la empresa
                    </span>
                  </div>
                </div>
                <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-cta/20" data-id="element-311">
                  <p className="text-cta font-semibold text-sm md:text-base" data-id="element-312">
                    Resultado: La empresa existe fiscalmente
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Arrow */}
          <div className="flex justify-center" data-id="element-313">
            <div className="w-px h-8 md:h-12 bg-gradient-to-b from-cta/50 to-cta/20" data-id="element-314"></div>
          </div>

          {/* Pilar 3 */}
          <div className="bg-bg-card p-6 md:p-8 lg:p-10 rounded-xl border border-cta/20 hover:border-cta/40 transition-colors" data-id="element-315">
            <div className="flex items-start gap-4 md:gap-6" data-id="element-316">
              <div className="flex-shrink-0" data-id="element-317">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-cta/10 rounded-lg flex items-center justify-center" data-id="element-318">
                  <CreditCardIcon className="w-6 h-6 md:w-8 md:h-8 text-cta" data-id="element-319" />
                </div>
              </div>
              <div className="flex-1" data-id="element-320">
                <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4" data-id="element-321">
                  <span className="text-cta font-bold text-base md:text-lg" data-id="element-322">
                    Pilar 3
                  </span>
                  <div className="h-px bg-cta/30 flex-1" data-id="element-323"></div>
                </div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-bold mb-2 md:mb-3" data-id="element-324">
                  Dominar — Infraestructura y Crédito
                </h3>
                <p className="text-text-secondary text-sm md:text-base lg:text-lg leading-relaxed mb-4 md:mb-6" data-id="element-325">
                  El proceso de construir la infraestructura financiera
                  empresarial.
                </p>
                <div className="space-y-2 md:space-y-3" data-id="element-326">
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-327">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-328" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-329">
                      Abrir la cuenta bancaria empresarial
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-330">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-331" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-332">
                      Separar las finanzas personales de las empresariales
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-333">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-334" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-335">
                      Crear historial financiero empresarial
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-336">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-337" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-338">
                      Preparar la empresa para operar financieramente
                    </span>
                  </div>
                </div>
                <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-cta/20" data-id="element-339">
                  <p className="text-cta font-semibold text-sm md:text-base" data-id="element-340">
                    Resultado: La empresa puede operar financieramente como una
                    entidad independiente
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Arrow */}
          <div className="flex justify-center" data-id="element-341">
            <div className="w-px h-8 md:h-12 bg-gradient-to-b from-cta/50 to-cta/20" data-id="element-342"></div>
          </div>

          {/* Pilar 4 */}
          <div className="bg-bg-card p-6 md:p-8 lg:p-10 rounded-xl border border-cta/20 hover:border-cta/40 transition-colors" data-id="element-343">
            <div className="flex items-start gap-4 md:gap-6" data-id="element-344">
              <div className="flex-shrink-0" data-id="element-345">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-cta/10 rounded-lg flex items-center justify-center" data-id="element-346">
                  <CalendarIcon className="w-6 h-6 md:w-8 md:h-8 text-cta" data-id="element-347" />
                </div>
              </div>
              <div className="flex-1" data-id="element-348">
                <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4" data-id="element-349">
                  <span className="text-cta font-bold text-base md:text-lg" data-id="element-350">
                    Pilar 4
                  </span>
                  <div className="h-px bg-cta/30 flex-1" data-id="element-351"></div>
                </div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-bold mb-2 md:mb-3" data-id="element-352">
                  Cumplir — El Calendario del Dueño
                </h3>
                <p className="text-text-secondary text-sm md:text-base lg:text-lg leading-relaxed mb-4 md:mb-6" data-id="element-353">
                  El proceso de mantener la empresa activa, protegida y en
                  cumplimiento.
                </p>
                <div className="space-y-2 md:space-y-3" data-id="element-354">
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-355">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-356" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-357">
                      Annual Reports
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-358">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-359" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-360">
                      Cumplimiento fiscal
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-361">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-362" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-363">
                      Supervisión contable
                    </span>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3" data-id="element-364">
                    <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 text-cta flex-shrink-0 mt-0.5 md:mt-1" data-id="element-365" />
                    <span className="text-text-secondary text-sm md:text-base" data-id="element-366">
                      Renovaciones empresariales
                    </span>
                  </div>
                </div>
                <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-cta/20" data-id="element-367">
                  <p className="text-cta font-semibold text-sm md:text-base" data-id="element-368">
                    Resultado: La empresa permanece activa y protegida
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 bg-gradient-to-r from-cta/10 to-transparent border-l-4 border-cta p-6 md:p-8 rounded-lg" data-id="element-369">
          <p className="text-base md:text-lg leading-relaxed" data-id="element-370">
            <span className="font-semibold text-cta" data-id="element-371">Regla fundamental:</span>{' '}
            Cada pilar depende del anterior. Saltar un pilar crea
            vulnerabilidades legales, fiscales o financieras. Este sistema te
            guía paso a paso para construir la infraestructura completa.
          </p>
        </div>
      </div>
    </section>;
}